import { useEffect, useState, useContext } from 'react';
import { FaUserAlt, FaBriefcase, FaCalendarAlt, FaUserCheck, FaPaperPlane } from 'react-icons/fa';
import { IoMdDoneAll, IoMdCloseCircleOutline } from "react-icons/io";
import { MdHourglassEmpty } from "react-icons/md";
import LoadingPage from '../../Loading';
import { DataProvider } from '../../../store/ContextProvider';

const STATUS_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Applied', value: 'applied' },
  { label: 'Saved', value: 'saved' },
];

export default function EmployerApplications() {
  const { BeURL, showAlert } = useContext(DataProvider);

  // state
  const [apps, setApps] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [statusFilter, setStatusFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [perPage] = useState(10); // fixed page size
  const [jobStatus, setJobStatus] = useState({})

  const [jobApps, setJobApps] = useState(null)

  // fetch whenever filter/page changes
  useEffect(() => {
    if (!BeURL) return;
    const qs = new URLSearchParams({ status: statusFilter, page, perPage }).toString();
    fetch(`${BeURL}/employer/applications?${qs}`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setApps(data.applications);
          setPagination(data.pagination);
        } else {
          showAlert(data.message);
        }
      })
      .catch(err => {
        console.error(err);
        showAlert('Unable to load applications.');
      });
  }, [BeURL, statusFilter, page, perPage, showAlert]);


  useEffect(() => {
    if (apps) {
      setJobApps(apps.filter(item => (item.saveStatus || item.applicationStatus)))
    }
  }, [apps])


  if (!jobApps || !pagination) {
    return <LoadingPage />
  }

  const statusOptions = [{ label: "Applied", value: "applied", Icon: FaPaperPlane, iconColors: "yellow" },
  { label: "On Hold", value: "holded", Icon: MdHourglassEmpty, iconColors: "orange" },
  { label: "Rejected", value: "rejected", Icon: IoMdCloseCircleOutline, iconColors: "red" },
  { label: "Shortlisted", value: "shortlisted", Icon: IoMdDoneAll, iconColors: "blue" },
  { label: "Hired", value: "hired", Icon: FaUserCheck, iconColors: "green" },];
  const { currentPage, totalPages } = pagination;

  const renderStatus = (app) => {
    if (app.applicationStatus) {
      return 'Applied'
    }
    else if (app.saveStatus) {
      return 'Saved'
    }
    else return 'No Records'
  }

  const handleStatusUpdation = (status, id,) => {
    const actualStatus = {
      shortlisted: "shortlisted",
      rejected: "rejected",
      applied: "applied",
      hired: "hired",
      holded: "holded"
    }

    fetch(`${BeURL}/update-application-status`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        "Content-type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ id: id, status: actualStatus[status] })
    })
      .then(res => res.json())
      .then(data => {
        showAlert(data.message);
        if (data.success) {
          window.location.reload()
        }
      })
      .catch(err => {
        console.log("Error in updating Application status:", err);
        showAlert('Trouble in updating Application status! please contact support team.');
      });
  }

  // const renderActionIcon = (Icon, action, id, status) => {

  //   const handleHover = (action, id) => {
  //     setIconAction(prev => ({
  //       ...prev,
  //       [id]: {
  //         ...prev[id],
  //         [action]: true
  //       }
  //     }));
  //   };

  //   const handleHoverOut = (action, id) => {
  //     setIconAction(prev => ({
  //       ...prev,
  //       [id]: {
  //         ...prev[id],
  //         [action]: false
  //       }
  //     }));
  //   };


  //   const iconColors = {
  //     rejected: 'red',
  //     shortlisted: 'green'
  //   };

  //   const hoverVisible = iconAction?.[id]?.[action];

  //   return (
  //     <div
  //       className={`flex gap-1 items-center relative ${status ? "cursor-not-allowed" : "cursor-pointer"}`}
  //       onMouseEnter={() => handleHover(action, id)}
  //       onMouseLeave={() => handleHoverOut(action, id)}
  //       onClick={() => handleStatusUpdation(action, id, status)}
  //     >
  //       <Icon className={`text-${iconColors[action]}-400`} />
  //       {hoverVisible && status !== "rejected" && (
  //         <span className={`absolute -top-1 left-[50%] translate-y-[-100%] translate-x-[-50%] text-xs px-2 rounded-xl font-semibold text-${iconColors[action]}-700 bg-${iconColors[action]}-100`}>
  //           {action}
  //         </span>
  //       )}
  //     </div>
  //   );
  // };

  const handleStatusChange = (id, status) => {
    // Update only this app's status
    setJobStatus(prev => ({ ...prev, [id]: status }));
    handleStatusUpdation(status, id);
  };

  // const renderHiringStatusBadge = (status) => {
  //   const iconColors = {
  //     rejected: 'red',
  //     shortlisted: 'green'
  //   }

  //   return (
  //     <div>
  //       <span className={`text-xs px-3 py-1 shadow rounded-xl font-semibold text-${iconColors[status]}-700 bg-${iconColors[status]}-100`}>{status || "Yet to update"}</span>
  //     </div>
  //   )
  // }

  return (
    <div className="p-6 space-y-4 min-h-[75vh]">
      <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-2xl my-4 font-semibold text-primary-400">Job Applications</h2>
        <div className="flex items-center gap-3">
          <label className="text-sm font-medium">Status:</label>
          <select
            value={statusFilter}
            onChange={e => { setStatusFilter(e.target.value); setPage(1); }}
            className="border rounded px-2 py-1"
          >
            {STATUS_OPTIONS.map(o =>
              <option key={o.value} value={o.value}>{o.label}</option>
            )}
          </select>
        </div>
      </header>

      {jobApps.length === 0
        ? <div className="p-6 text-gray-500">No applications found.</div>
        : (
          <div className="overflow-x-auto">
            <table className="w-full bg-white rounded-lg shadow-md">
              <thead className="text-primary-400 bg-blue-50">
                <tr>
                  <th className="p-2 text-left font-semibold">Job</th>
                  <th className="p-2 text-left font-semibold">Candidate</th>
                  <th className="p-2 text-left font-semibold">Type</th>
                  <th className="p-2 text-left font-semibold">Applied At</th>
                  <th className="p-2 text-left font-semibold">Action</th>
                </tr>
              </thead>
              <tbody>
                {apps.map(app => (
                  <tr key={app._id} className="border-b hover:bg-gray-50 transition">
                    <td className="p-4">
                      <div className='flex items-center gap-3'>
                        <FaBriefcase className="text-slate-500 cursor-pointer" onClick={() => window.location.href = `/job/${app.job._id}`} />
                        <div>
                          <div className="font-medium cursor-pointer" onClick={() => window.location.href = `/job/${app.job._id}`}>{app.job.title}</div>
                          <div className="text-sm text-gray-500 cursor-pointer" onClick={() => window.location.href = `/job/${app.job._id}`}>ID: {app.job.id}</div>
                        </div>
                      </div>
                    </td>
                    <td className="p-4">
                      <div className='flex items-center gap-3'>
                        <FaUserAlt className="text-slate-500 cursor-pointer" onClick={() => window.location.href = `/candidate/${app.candidate._id}`} />
                        <div>
                          <div className="font-medium cursor-pointer" onClick={() => window.location.href = `/candidate/${app.candidate._id}`}>{app.candidate.applicantName}</div>
                          <div className="text-sm text-gray-500 cursor-pointer" onClick={() => window.location.href = `/candidate/${app.candidate._id}`}>{app.candidate.emailAddress}</div>
                        </div>
                      </div>
                    </td>
                    <td className="p-4">
                      <span>
                        {renderStatus(app)}
                      </span>
                    </td>
                    <td className="p-4 flex items-center gap-2">
                      <FaCalendarAlt className="text-slate-500" />
                      {new Date(app.appliedAt).toLocaleDateString('en-GB')}
                    </td>
                    <td className='p-4'>
                      {
                        (app.saveStatus && !app.applicationStatus) ?
                          " - "

                          :
                          <div className="text-lg flex gap-2 items-center" key={app._id}>
                            

                            <select
                              value={jobStatus[app.id] || app.hiringStatus}
                              onChange={(e) => handleStatusChange(app.id, e.target.value)}
                              className={`
      border rounded-md px-2 py-1 text-sm font-semibold
      ${(() => {
                                  const selected = statusOptions.find(
                                    s => s.value === (jobStatus[app.id] || app.hiringStatus)
                                  );
                                  return `text-${selected.iconColors}-700 `;
                                })()}
    `}
                            >
                              {statusOptions.map(sta => (
                                <option key={sta.value} value={sta.value}>
                                  {sta.label}
                                </option>
                              ))}
                            </select>
                          </div>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      }
      {/* {renderActionIcon(IoMdCloseCircleOutline, 'reject', app.id, app.hiringStatus)}
                                {renderActionIcon(IoMdDoneAll, 'shortlist', app.id, app.hiringStatus)} */}
      {/* pagination */}
      <div className="flex justify-center items-center gap-4 mt-6">
        <button
          disabled={currentPage === 1}
          onClick={() => setPage(p => p - 1)}
          className="px-3 py-1 rounded-lg bg-white shadow"
        >Prev</button>
        <span>Page {currentPage} of {totalPages}</span>
        <button
          disabled={currentPage === totalPages}
          onClick={() => setPage(p => p + 1)}
          className="px-3 py-1 rounded-lg bg-white shadow"
        >Next</button>
      </div>
    </div>
  );
}
